module.exports = __webpack_public_path__ + "img/logo_white.cb2af2f0.svg";